export const LOADER_STATUS = 'LOADER_STATUS';
export const COMPANIES_DATA = 'COMPANIES_DATA';
export const TOTAL_RECORD = 'boilerplate/company/TOTAL_RECORD'
export const GET_ALL_GROUPS = 'boilerplate/company/GET_ALL_GROUPS';